var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuarioRestaurar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 300,
    viewBox: "0 0 24 24",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    fill: "#000",
    transform: "translate(-477 -141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_030-sync-profile-account-people",
    transform: "translate(479 143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "matrix(.985 -.174 .174 .985 10.302 13.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "m10.1047681 5.32876732c-.0621185-.26906487-.33059569-.43682803-.59966055-.37470951-.26906487.06211852-.43682803.3305957-.37470951.59966056l.44990211 1.94874013c.06211852.26906487.3305957.43682803.59966055.37470951.2690649-.06211852.436828-.3305957.3747095-.59966056z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "m7.55636742 5.40395992c-.26906487.06211852-.43682803.3305957-.37470951.59966056.06211852.26906487.3305957.43682803.59966056.37470951l1.94874013-.44990211c.26906486-.06211852.436828-.3305957.3747095-.59966056-.0621185-.26906487-.33059569-.43682803-.59966055-.37470951z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "m.85163309 3.71045859c.06211852.26906486.3305957.43682802.59966056.3747095.26906487-.06211852.43682803-.33059569.37470951-.59966056l-.44990211-1.94874013c-.06211852-.26906486-.3305957-.43682802-.59966056-.3747095-.26906486.06211851-.43682802.33059569-.37470951.59966056z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "m3.40003378 3.63526598c.26906486-.06211852.43682802-.33059569.37470951-.59966056-.06211852-.26906486-.3305957-.43682802-.59966056-.3747095l-1.94874013.44990211c-.26906487.06211851-.43682803.33059569-.37470951.59966056.06211852.26906486.3305957.43682802.59966056.3747095z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "m5.5 9c2.06863571 0 3.85602192-1.40738289 4.3604957-3.3843246.06827777-.26756823-.09327908-.53982521-.36084731-.60810297s-.5398252.09327908-.60810296.36084732c-.39212393 1.53666288-1.78267672 2.63158025-3.39154543 2.63158025-1.60735843 0-2.99695362-1.09287939-3.39052212-2.62758003-.06859604-.26748681-.34104502-.42871964-.60853183-.36012361-.26748681.06859604-.42871964.34104502-.3601236.60853183.50632981 1.97440777 2.29248607 3.37917181 4.35917755 3.37917181zm0-9c-2.06496076 0-3.85002094 1.4024346-4.35799888 3.37458571-.06887931.26741401.09206486.54003361.35947886.60891292.26741401.06887932.54003361-.09206485.60891293-.35947886.39485128-1.53295317 1.78359308-2.62401977 3.38960709-2.62401977 1.60527159 0 2.99354173 1.09006609 3.38910013 2.62205396.06903574.26737367.34174944.42815833.60912311.3591226s.42815833-.34174943.3591226-.6091231c-.50888644-1.97090453-2.29334084-3.37205346-4.35734584-3.37205346z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "m10 19c-4.97056275 0-9-4.0294373-9-9 0-4.97056275 4.02943725-9 9-9 4.9705627 0 9 4.02943725 9 9 0 1.0830336-.191136 2.1390412-.5599167 3.13232-.0961144.2588757.0358298.546652.2947055.6427664s.546652-.0358298.6427664-.2947055c.4099819-1.1042507.6224448-2.2780871.6224448-3.4803809 0-5.5228475-4.4771525-10-10-10s-10 4.4771525-10 10 4.4771525 10 10 10c1.2022938 0 2.3761302-.2124629 3.4803809-.6224448.2588757-.0961144.3908199-.3838907.2947055-.6427664s-.3838907-.3908199-.6427664-.2947055c-.9932788.3687807-2.0492864.5599167-3.13232.5599167z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "m10 13c1.554798 0 2.9374525.2228168 4.1191579.639876.2604005.0919031.545999-.0446911.6379021-.3050916s-.044691-.545999-.3050915-.6379021c-1.2919256-.4559592-2.7869359-.6968823-4.4519685-.6968823-3.76865296 0-6.66680047 1.2541637-8.11893423 3.251148-.16240315.2233379-.11300575.5360428.11033217.698446.22333792.1624031.53604285.1130057.698446-.1103322 1.24873291-1.717266 3.84146402-2.8392618 7.31015606-2.8392618z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-63",
    d: "m14 7c0-2.209139-1.790861-4-4-4s-4 1.790861-4 4 1.790861 4 4 4 4-1.790861 4-4zm-7 0c0-1.65685425 1.34314575-3 3-3 1.6568542 0 3 1.34314575 3 3s-1.3431458 3-3 3c-1.65685425 0-3-1.34314575-3-3z",
    fill: "#1d252c",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarioRestaurar);
export default __webpack_public_path__ + "static/media/usuario_restaurar.a35823d10b0e3ddb06f7c55fb765504d.svg";
export { ForwardRef as ReactComponent };